import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { mapFacilityType } from "@/lib/profileForm";

export const OTHER_FACILITY = "__other__";

export function PreviousFacilityPicker({ value, mode, editable, onPick, onOther, onType, label = "Previous Facility Name", testId = "profile-prev" }) {
  const [q, setQ] = useState(value || "");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const timer = useRef(null);
  useEffect(() => { setQ(value || ""); }, [value]);
  useEffect(() => () => clearTimeout(timer.current), []);

  const search = (text) => {
    setQ(text); onType(text); setOpen(true);
    clearTimeout(timer.current);
    if (text.trim().length < 2) { setResults([]); return; }
    timer.current = setTimeout(() => {
      api.get("/facilities-reference/search", { params: { q: text.trim() } }).then((r) => setResults(r.data)).catch(() => setResults([]));
    }, 250);
  };

  if (mode === OTHER_FACILITY) {
    return (
      <div className="space-y-1.5">
        <Label htmlFor={`${testId}-name`}>{label} (not in the list) <span className="text-destructive">*</span></Label>
        <Input id={`${testId}-name`} data-testid={`${testId}-name`} value={value || ""} disabled={!editable} maxLength={200}
          placeholder="Type the facility name" onChange={(e) => onType(e.target.value)} />
        {editable && <Button type="button" variant="link" size="sm" className="h-auto p-0" onClick={() => onOther(false)} data-testid={`${testId}-search-again`}>Search the facility list instead</Button>}
      </div>
    );
  }
  return (
    <div className="relative space-y-1.5">
      <Label htmlFor={`${testId}-name`}>{label} <span className="text-destructive">*</span></Label>
      <Input id={`${testId}-name`} data-testid={`${testId}-name`} value={q} disabled={!editable} autoComplete="off"
        placeholder="Type at least 2 letters to search" onChange={(e) => search(e.target.value)}
        onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)} />
      {open && editable && q.trim().length >= 2 && (
        <div className="absolute z-30 mt-1 w-full max-h-64 overflow-auto rounded-md border border-border bg-popover shadow-lg" data-testid={`${testId}-results`}>
          {results.map((f, i) => (
            <button type="button" key={`${f.name}-${i}`} data-testid={`${testId}-result-${i}`}
              className="block w-full px-3 py-2 text-left text-sm transition-colors hover:bg-accent"
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => { onPick({ name: f.name, region: f.region, location: [f.town, f.district, f.region].filter(Boolean).join(", "), type: mapFacilityType(f.type) }); setOpen(false); }}>
              <span className="font-medium">{f.name}</span>
              <span className="block text-xs text-muted-foreground">{[f.district, f.region].filter(Boolean).join(", ")}</span>
            </button>
          ))}
          <button type="button" data-testid={`${testId}-other`} onMouseDown={(e) => e.preventDefault()}
            className="block w-full border-t border-border px-3 py-2 text-left text-sm font-medium text-primary transition-colors hover:bg-accent"
            onClick={() => { onOther(true); setOpen(false); }}>
            Other – not in the list
          </button>
        </div>
      )}
    </div>
  );
}
